import type { ChangeEvent, FC } from 'react'

import { cleanUpPhone } from '@/helpers'
import { Button, Flex, Input } from '@/components'
import { useAuthStore } from '../../store'
import { AuthCaptcha } from '../auth-captcha'
import { useGetPhoneToCallMutation } from './use-get-phone-to-call-mutation'
import { formatAnyInputToPhoneMask, phoneMask } from '@/components/input/helpers'


export const InitialScreen: FC = () => {
  const userPhone = useAuthStore((s) => s.userPhone)
  const setUserPhone = useAuthStore((s) => s.setUserPhone)

  const {
    startGetPhoneToCall,
    isGetPhoneToCallPending,
    captcha,
    onCaptchaToken,
    onCaptchaFail,
    onCaptchaRefresh,
  } = useGetPhoneToCallMutation()

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget
    const digits = value.replace(/\D/g, '')

    // Обработка автозаполнения
    if (digits.length >= 11) {
      if (digits.startsWith('77') || digits.startsWith('78')) {
        setUserPhone(formatAnyInputToPhoneMask(value))
        return
      }
    }

    setUserPhone(value)
  }


  return <>
    <Flex
      gap={20}
      justify='center'
      align='center'
      vertical
    >
      <div style={{ fontWeight: 500, fontSize: '33px', textAlign: 'center' }}>
        Добро пожаловать!
      </div>

      <p style={{ fontSize: '14px', textAlign: 'center' }}>
        Укажите, пожалуйста, свой номер телефона, чтобы войти или зарегистрироваться
      </p>

      <Input
        label='Телефон'
        name='phone'
        $isPhone
        value={userPhone}
        onChange={handlePhoneChange}
        setFunction={setUserPhone}
      />

      {captcha && (
        <AuthCaptcha
          challenge={captcha}
          onToken={onCaptchaToken}
          onFail={onCaptchaFail}
          onRefresh={onCaptchaRefresh}
        />
      )}

      <Button
        type='primary'
        onClick={startGetPhoneToCall}
        loading={isGetPhoneToCallPending}
        block
        disabled={
          userPhone === phoneMask
          || (cleanUpPhone(userPhone).slice(2).length < 10)
        }
      >
        Продолжить
      </Button>
    </Flex>
  </>
}

